<template>
    <v-row>
        <v-card-text>
            <validation-provider
                v-slot="{ errors }"
                :name="$t('oampublication/label--praxisstellen-fachrichtung-text')"
                rules="required"
            >
                <v-select
                    v-model="praxisstellenFachrichtungText"
                    :items="cboPraxisstellenFachrichtung"
                    item-text="text"
                    item-value="text"
                    :label="$t('oampublication/label--praxisstellen-fachrichtung-text')"
                    :error-messages="errors"
                    required
                    clearable
                ></v-select>
            </validation-provider>
        </v-card-text>
    </v-row>
</template>

<script>
import { cboService } from '@/services'
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider } from 'vee-validate'

export default {
    components: {
        ValidationProvider,
    },
    data: () => ({
        connectorId: -21,
        loading: true,
        cboPraxisstellenFachrichtung: [],
    }),
    computed: {
        ...mapGetters('pub', ['getExtensionValueByKey']),
        praxisstellenFachrichtungText: {
            get: function () {
                return this.getExtensionValueByKey('PraxisstellenFachrichtungText')
            },
            set: function (val) {
                this.editExtension({ key: 'PraxisstellenFachrichtungText', value: val })
            },
        },
    },
    mounted() {
        cboService.getItems('PraxisstellenFachrichtung').then((items) => {
            this.cboPraxisstellenFachrichtung = items
            this.loading = false
            this.$emit('child-rendered')
        })
    },
    methods: {
        ...mapActions('pub', ['editExtension']),
    },
}
</script>

<style scoped></style>
